import { clone } from 'lodash-es';
import { detach, getParent, getParentOfType, getRoot, getSnapshot, getType, isRoot, types, } from 'mobx-state-tree';
// import { IRootModel } from 'RootModel';
import { v4 } from 'uuid';
import { Tokens } from '@mcn-platform/converse-lib';
import { moveItem } from './CourseModel';
import schema, { generateType } from './Schema';
import { SelectionWizardModel } from './SelectionWizardModel';
import { slugify } from './itemCommon';
const portalTemplate = generateType(schema.getModel('portalTemplate'));
export const PortalTemplate = portalTemplate;
const aiConfigurationOverrides = new Map([
    ['wizards', types.optional(types.array(SelectionWizardModel), [])],
]);
export const AIConfiguration = generateType(schema.getModel('aiConfiguration'), aiConfigurationOverrides);
export const LearningBoardConfiguration = generateType(schema.getModel('learningBoardConfiguration'));
const portalModel = generateType(schema.getModel('portal'));
export const Portal = portalModel
    .volatile((self) => ({
    tokenProvider: new Tokens(self),
}))
    .actions((self) => ({
    // This is an auto-generated example action.
    log() {
        console.log(JSON.stringify(self));
    },
    initCategories() {
        // don't reinit
        if (self.categories && self.categories.length > 0) {
            return;
        }
        self.categories = [
            {
                id: v4(),
                name: 'Categories',
            },
            {
                id: v4(),
                name: 'Groups',
            },
        ];
    },
    addCategory(name) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const newCategory = Category.create({
            id: v4(),
            name,
        });
        self.subCategories.push(newCategory);
        self.addChange();
        return newCategory;
    },
    afterAttach() {
        // console.log('PORTAL after attach called');
        const rootModel = getRoot(self); // as IRootModel;
        // const portalID = localStorage.getItem('currentPortalID');
        // if (portalID && self.id !== portalID) {
        //   return;
        // }
        if (rootModel && !rootModel.currentPortal) {
            // console.log('Set currentPortal', self);
            rootModel.setCurrentPortal(self);
            // hack way to wait for adminSession to be initialized
            // rootModel.setnStatus('ready');
        }
    },
    addTemplate(id, parentId, subType, name = 'New Template') {
        // console.log('Add template', id);
        const config = {
            name,
            props: {},
            overrides: {},
        };
        config.type = 'template';
        config.subType = subType || 'template';
        if (parentId) {
            config.extends = parentId;
        }
        else {
            config.component = 'RowLayout';
            config.props = {
                items: [],
            };
        }
        // put the config in the config map
        const configs = clone(self.configs);
        configs[id] = config;
        self.configs = configs;
        self.addChange();
        return config;
    },
    deleteTemplate(id) {
        // Clone the config and then delete the item based on ID
        const configs = clone(self.configs);
        delete configs[id];
        // Update the config.
        self.configs = configs;
        self.addChange();
    },
    setPortalConfigs(newConfigs) {
        self.configs = newConfigs;
        self.addChange();
    },
    addPortalConfig(newId, newConfig) {
        // put the config in the config map
        const configs = clone(self.configs);
        configs[newId] = newConfig;
        self.configs = configs;
        self.addChange();
    },
    updatePageDefaults(newDefaults) {
        self.pageDefaults = newDefaults;
        self.addChange();
    },
    setDefaultPage(path, pageID) {
        const newDefaults = { ...self.pageDefaults };
        newDefaults[path] = pageID;
        self.pageDefaults = newDefaults;
        self.addChange();
    },
    updatePageRules(newPageRules) {
        self.pageRules = newPageRules;
        self.addChange();
    },
    async preUpdate(isNew) {
        console.log('Portal.preUpdate called', { self, isNew });
        const slugMap = new Map();
        const generateUniqueSlug = (category, baseSlug, parentSlug) => {
            let slug = baseSlug;
            if (slugMap.has(slug)) {
                slug = `${baseSlug}-${slugify(category.description.substring(0, 25))}`;
            }
            if (slugMap.has(slug) && parentSlug) {
                slug = `${baseSlug}-${parentSlug}`;
            }
            if (slugMap.has(slug)) {
                slug = `${baseSlug}-${category.id}`;
            }
            slugMap.set(slug, true);
            return slug;
        };
        const updateCategorySlugs = (category, parentSlug) => {
            let baseSlug;
            if (category.manualSlug) {
                baseSlug = slugify(category.slug);
                if (slugMap.has(baseSlug)) {
                    category.slug = generateUniqueSlug(category, baseSlug, parentSlug);
                }
                else {
                    category.slug = baseSlug;
                    slugMap.set(category.slug, true);
                }
            }
            else {
                baseSlug = slugify(category.name);
                category.slug = generateUniqueSlug(category, baseSlug, parentSlug);
            }
            for (let i = 0; i < category.subCategories.length; i += 1) {
                updateCategorySlugs(category.subCategories[i], category.slug);
            }
        };
        for (let i = 0; i < self.categories.length; i += 1) {
            updateCategorySlugs(self.categories[i], null);
        }
    },
    addChange() {
        if (self.changeCount !== undefined) {
            self.changeCount += 1;
        }
    },
}))
    .views((self) => ({
    getCategory(categoryId) {
        if (self.syncState !== 'loaded') {
            throw Error(`Portal must be loaded before calling getCatetory: ${self.id}, ${self.syncState}`);
        }
        for (let i = 0; i < self.categories.length; i += 1) {
            const c = self.categories[i];
            const foundCat = c.getSubCategory(categoryId);
            if (foundCat) {
                return foundCat;
            }
        }
        return undefined;
    },
    getCategoryBySlug(categorySlug) {
        if (self.syncState !== 'loaded') {
            throw Error(`Portal must be loaded before calling getCatetory: ${self.id}, ${self.syncState}`);
        }
        for (let i = 0; i < self.categories.length; i += 1) {
            const c = self.categories[i];
            const foundCat = c.getSubCategoryBySlug(categorySlug);
            if (foundCat) {
                return foundCat;
            }
        }
        return undefined;
    },
    getCategoryPath(categoryId) {
        if (self.syncState !== 'loaded') {
            throw Error(`Portal must be loaded before calling getCatetory: ${self.id}, ${self.syncState}`);
        }
        for (let i = 0; i < self.categories.length; i += 1) {
            const c = self.categories[i];
            const path = c.getCategoryPath(categoryId);
            if (path) {
                // note we are returning the top category here
                return path;
            }
        }
        throw new Error(`Category not found ${categoryId}`);
    },
    clone() {
        const newPortal = {
            ...getSnapshot(self),
            id: v4(),
            name: `Copy of ${self.name}`,
        };
        console.log('newPortal', newPortal);
        return newPortal;
    },
    getToken(key, variables) {
        if (!self.tokenProvider) {
            console.log('TokenProvider not configured');
            return '';
        }
        return self.tokenProvider.getToken(key, variables);
    },
    getLibraryIDs() {
        const ids = [
            self.defaultLibrary.id,
            ...(self.libraries?.map((l) => l.id) || []),
            ...(self.libraryShares?.map((l) => l.libraryID) || []),
        ].filter(Boolean);
        return [...new Set(ids)];
    },
}));
const categoryModel = generateType(schema.getModel('category'));
export const Category = categoryModel
    .views(() => ({
    isAncestor(child, possibleParent) {
        let parent = getParent(child);
        while (parent) {
            if (parent === possibleParent) {
                // console.log('Is an ancestor', {child: child.name, parent: possibleParent.name});
                return true;
            }
            parent = isRoot(parent) ? null : getParent(parent);
        }
        // console.log('Not an ancestor', {child: child.name, parent: possibleParent.name});
        return false;
    },
}))
    .actions((self) => ({
    addChange() {
        try {
            getParentOfType(self, Portal).addChange();
        }
        catch (e) {
            console.log('error adding change', e);
        }
    },
    addCategory(name) {
        const newCategory = Category.create({
            id: v4(),
            name,
            displayInNavigation: true,
            active: true,
        });
        self.subCategories.push(newCategory);
        this.addChange();
        return newCategory;
    },
    removeCategory(subCategory) {
        detach(subCategory);
        this.addChange();
    },
    insertCategory(subCategory, atIndex) {
        if (atIndex < 0) {
            self.subCategories.push(subCategory);
        }
        else {
            self.subCategories.splice(atIndex, 0, subCategory);
        }
        this.addChange();
    },
    moveSubCategory(subCategory, newIndex) {
        const currentIndex = self.subCategories.indexOf(subCategory);
        const adjustedNewIndex = newIndex > currentIndex ? newIndex - 1 : newIndex;
        const tempArray = self.subCategories.slice();
        moveItem(tempArray, currentIndex, adjustedNewIndex);
        self.subCategories.replace(tempArray);
        this.addChange();
    },
    /**
   * Moves a category to a new location in the course tree.
   *
   * @param categoryToMove
   * @param target
   * @param index
   */
    moveCategory(categoryToMove, newParent, newIndex) {
        // if moving within the same list - need to adjust the index
        const currentParent = categoryToMove.getParent();
        if (currentParent.id === newParent.id) {
            currentParent.moveSubCategory(categoryToMove, newIndex);
        }
        else {
            currentParent.removeCategory(categoryToMove);
            newParent.insertCategory(categoryToMove, newIndex);
        }
        this.addChange();
    },
    deleteItem(item) {
        const deleteIndex = self.items.indexOf(item);
        self.items.splice(deleteIndex, 1);
        self.addChange();
    },
}))
    .views((self) => ({
    getParent() {
        const parent = getParent(self, 2);
        // console.log('type', getType(parent));
        if (getType(parent).name === 'Portal') {
            return null;
        }
        return parent;
    },
    canAdd() {
        // @todo - not if we are top level
        return true;
    },
    canDelete() {
        // @todo can't delete root categories
        if (self.subCategories.length > 0) {
            return false;
        }
        return true;
    },
    getSubCategory(categoryId) {
        // console.log('Looking in/for', { self: self.id, categoryId });
        if (categoryId === self.id) {
            return self;
        }
        let foundCat;
        // check my subs
        for (let i = 0; i < self.subCategories.length; i += 1) {
            const subCat = self.subCategories[i];
            foundCat = subCat.getSubCategory(categoryId);
            if (foundCat) {
                return foundCat;
            }
        }
        return undefined;
    },
    getSubCategoryBySlug(categorySlug) {
        // console.log('Looking in/for', { self: self.slug, categorySlug });
        if (categorySlug === self.slug || categorySlug === self.id) {
            return self;
        }
        // check my subs
        for (let i = 0; i < self.subCategories.length; i += 1) {
            const subCat = self.subCategories[i];
            const foundCat = subCat.getSubCategoryBySlug(categorySlug);
            if (foundCat) {
                return foundCat;
            }
        }
        return undefined;
    },
    getCategoryPath(categoryId) {
        // console.log('Looking in/for', { self: self.id, categoryId });
        if (categoryId === self.id) {
            return [self];
        }
        // check my subs
        for (let i = 0; i < self.subCategories.length; i += 1) {
            const subCat = self.subCategories[i];
            const foundPath = subCat.getCategoryPath(categoryId);
            if (foundPath) {
                return [self, ...foundPath];
            }
        }
        return undefined;
    },
    canReceive(categoryToMove, newParent, newIndex) {
        if (!newParent) {
            console.log('newParent', newParent);
            return false;
        }
        // if moving within the same list - need to adjust the index
        const currentParent = categoryToMove.getParent();
        const currentIndex = currentParent.subCategories.indexOf(categoryToMove);
        // if a section has an item, into cant receive items or subsections
        if (!newParent.canAdd()) {
            return false;
        }
        // already here
        if (currentParent.id === newParent.id
            && (newIndex === currentIndex || newIndex === currentIndex + 1)) {
            return false;
        }
        // cant move to yourself
        if (categoryToMove === newParent) {
            return false;
        }
        // cant move a node to one if its children
        if (self.isAncestor(newParent, categoryToMove)) {
            return false;
        }
        return true;
    },
}));
const membershipModel = generateType(schema.getModel('membership'));
export const Membership = membershipModel
    .views((self) => ({
    summary() {
        const freeTrial = self.trialEnabled ? `${self.trialDays} day free trial.` : 'No free trial.';
        const taxExempt = self.taxExempt ? 'Tax exempt.' : '';
        if (self.paymentPlan === 'recurring') {
            return `Recurring membership $${self.recurringPrice} billed ${self.recurringTerm}. ${freeTrial} ${taxExempt}`;
        }
        if (self.paymentPlan === 'installments') {
            return `Installment membership $${self.installmentPrice} billed ${self.installmentRecurrence} for ${self.installmentCount} installments. ${freeTrial} ${taxExempt}`;
        }
        if (self.paymentPlan === 'onetime') {
            return `One time payment of $${self.onetimePrice}. ${freeTrial} ${taxExempt}`;
        }
        return `Installment type not recognized ${self.type}`;
    },
    conversionValue() {
        if (self.paymentPlan === 'recurring') {
            if (self.recurringTerm === 'weekly') {
                return self.recurringPrice * 52;
            }
            if (self.recurringTerm === 'monthly') {
                return self.recurringPrice * 12;
            }
            if (self.recurringTerm === 'quarterly') {
                return self.recurringPrice * 4;
            }
            if (self.recurringTerm === 'yearly') {
                return self.recurringPrice;
            }
        }
        if (self.paymentPlan === 'installments') {
            return self.installmentPrice * self.installmentCount;
        }
        if (self.paymentPlan === 'onetime') {
            return self.onetimePrice;
        }
        return 0;
    },
    checkoutUrl() {
        // @todo - where should the portal root come from?
        return `checkout?type=membership&id=${self.id}`;
    },
}));
const memberModel = generateType(schema.getModel('member'));
export const Member = memberModel;
const memberFields = (portalApi) => (`
  id
  ${portalApi ? '' : 'organizationID'}
  ${portalApi ? '' : 'customerID'}
  membershipID
  name
  status
  createdAt
  updatedAt
  lastPaymentAt
  nextPaymentAt
  failedPaymentAttempts
  ${portalApi ? '' : 'stripeSessionID stripePaymentIntentID stripeSubscriptionID stripeCustomerID stripeInvoiceID'}  
`);
export const startCheckoutGQL = (portalApi) => ( /* GraphQL */`
  mutation StartCheckout(
    ${portalApi ? '' : '$organizationID: String'}
    $portalID: String
    $returnUrl: String
    $cancelUrl: String
    $items: [CheckoutItemInput]
  ) {
    startCheckout(
      ${portalApi ? '' : 'organizationID: $organizationID'}
      portalID: $portalID
      returnUrl: $returnUrl
      cancelUrl: $cancelUrl
      items: $items
    ) {
      statusCode
      member {
        ${memberFields(portalApi)}
      }
      checkoutUrl
      message
      richText
    }
  }
`);
export const verifyCheckoutGQL = (portalApi) => ( /* GraphQL */`
  mutation VerifyCheckout(
    ${portalApi ? '' : '$organizationID: String'}
    $portalID: String
    $memberID: String
  ) {
    verifyCheckout(
      ${portalApi ? '' : 'organizationID: $organizationID'}
      portalID: $portalID
      memberID: $memberID
    ) {
      statusCode
      member {
        ${memberFields(portalApi)}
      }
      success
      message
    }
  }
`);
export const swapMembershipGQL = (portalApi) => ( /* GraphQL */`
  mutation SwapMembership(
    ${portalApi ? '' : '$organizationID: String'}
    $portalID: String
    $existingMemberID: String
    $newMembershipID: String
  ) {
    swapMembership(
      ${portalApi ? '' : 'organizationID: $organizationID'}
      portalID: $portalID
      existingMemberID: $existingMemberID
      newMembershipID: $newMembershipID
    ) {
      statusCode
      expiredMember {
        ${memberFields(portalApi)}
      }
      newMember {
        ${memberFields(portalApi)}
      }
      success
      message
    }
  }
`);
export const deployPortalGql = `
  mutation DeployPortal(
    $organizationID: String!
    $portalID: String!
  ) {
    deployPortal(
      organizationID: $organizationID
      portalID: $portalID
    ) {
      ${schema.getGqlPropertyList('portal', false, true, false).join(' ')}
    }
  }
`;
//# sourceMappingURL=PortalModel.js.map